import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { formatDateTime, formatRelativeTime } from 'nallian-shared-ui/lib/lib/dateTime';
import { Loader, Grid, Table, Header, Flex } from 'nallian-shared-ui/lib/components';
import CopyToClipboard from '../../../app/components/CopyToClipboard';

const AppInfo = ({ appFetch }) => {
  const { t } = useTranslation();
  const app = appFetch.value || {};

  if (appFetch.pending) {
    return <Loader active={appFetch.pending} inline="centered" />;
  }

  return (
    <Grid columns={2} stackable>
      <Grid.Column>
        <Header>{t('general')}</Header>
        <Table>
          <Table.Row>
            <Table.HeaderCell width={4}>{t('name')}</Table.HeaderCell>
            <Table.Cell>{app.name}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('description')}</Table.HeaderCell>
            <Table.Cell>{app.description || '-'}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('tag')}</Table.HeaderCell>
            <Table.Cell>{app.tag || '-'}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('shortName')}</Table.HeaderCell>
            <Table.Cell>{app.shortName || '-'}</Table.Cell>
          </Table.Row>
        </Table>
        <Header>{t('metaData')}</Header>
        <Table>
          <Table.Row>
            <Table.HeaderCell width={4}>{t('createdOn')}</Table.HeaderCell>
            <Table.Cell>
              {`${formatDateTime(app.createdOn)}`}
              &nbsp;-&nbsp;
              {formatRelativeTime(app.createdOn)}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('lastModifiedOn')}</Table.HeaderCell>
            <Table.Cell>
              {`${formatDateTime(app.modifiedOn)}`}
              &nbsp;-&nbsp;
              {formatRelativeTime(app.modifiedOn)}
            </Table.Cell>
          </Table.Row>
        </Table>
      </Grid.Column>
      <Grid.Column>
        <Header>{t('data')}</Header>
        <Table>
          <Table.Row>
            <Table.HeaderCell width={4}>{t('id')}</Table.HeaderCell>
            <Table.Cell>
              <Flex fluid alignItems="center" justifyContent="space-between">
                {app.id}
                <CopyToClipboard value={app.id} />
              </Flex>
            </Table.Cell>
          </Table.Row>
        </Table>
      </Grid.Column>
    </Grid>
  );
};

AppInfo.propTypes = { appFetch: PropTypes.object.isRequired };

export default AppInfo;
